/**
 *  @class
 *  @function RecentlyViewedProducts
 */
/**
 *  @class
 *  @function RecentlyViewedProducts
 */
if (!customElements.get('recently-viewed-products')) {
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();

      this.baseUrl = `${theme.routes.search_url}?view=recently-viewed&type=product&q=`;
      this.container = this.querySelector('.products');
      this.currentId = this.dataset.productHandle;
      this.max = Number(this.dataset.max);
      this.products = '';
      try {
        const recentIds = window.localStorage.getItem('recently-viewed');
        const parsedIds = recentIds ? JSON.parse(recentIds) : [];
        if (Array.isArray(parsedIds)) window.recentlyViewedIds = parsedIds;
      } catch (error) {
        // Browsing history is optional when storage is unavailable.
      }
    }


    connectedCallback() {
      if (!this.hasAttribute('data-defer-until-visible')) {
        this.buildUrl();
        return;
      }
      if (this.deferredLoading || this.deferredLoaded) return;

      // The element is hidden until loaded; observe its visible section wrapper.
      const target = this.closest('.shopify-section') || this.parentElement;
      if (!('IntersectionObserver' in window) || !target) {
        this.loadDeferredProducts();
        return;
      }
      this.visibilityObserver?.disconnect();
      this.visibilityObserver = new IntersectionObserver((entries) => {
        if (!this.isConnected || !entries.some(entry => entry.isIntersecting)) return;
        this.visibilityObserver.disconnect();
        this.loadDeferredProducts();
      }, { rootMargin: '400px 0px' });
      this.visibilityObserver.observe(target);
    }

    disconnectedCallback() {
      this.visibilityObserver?.disconnect();
    }

    loadDeferredProducts() {
      if (this.deferredLoading || this.deferredLoaded) return;
      this.deferredLoading = true;
      this.buildUrl()
        .then(success => { this.deferredLoaded = success; })
        .finally(() => { this.deferredLoading = false; });
    }

    buildUrl() {
      const recentIds = Array.isArray(window.recentlyViewedIds) ? window.recentlyViewedIds : [];
      const productHandles = recentIds.filter(val => typeof val === 'string' && val && val !== this.currentId).slice(0, this.max);
      if (!productHandles.length) return Promise.resolve(true);
      this.products = productHandles.map(handle => `handle:${handle}`).join(' OR ');
      this.url = this.baseUrl + encodeURIComponent(this.products);

      return this.fetchProducts();
    }

    fetchProducts() {
      return fetch(this.url)
        .then(response => {
          if (!response.ok) throw new Error('Unable to load recently viewed products');
          return response.text();
        })
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('.products');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.container.innerHTML = recommendations.innerHTML;
            this.classList.add('recently-viewed-products--loaded');
            this.container.querySelectorAll('.lazyload').forEach((image) => {
              lazySizes.loader.unveil(image);
            });
          }
          return true;
        })
        .catch(e => {
          console.error(e);
          return false;
        });
    }
  }

  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}
